import React from "react";
import moment from "moment";
import { GridHourCol, GridHourColItem, GridHourColItemInner } from "./styles";

const HourColumn = ({ pixelsPerMinute }) => (
  <GridHourCol>
    {Array(25)
      .fill(null)
      .map((_, hourIndex) => (
        <GridHourColItem
          key={hourIndex}
          style={{ height: `${pixelsPerMinute * 60}px` }}
        >
          <GridHourColItemInner>
            {getHourString(hourIndex)}
          </GridHourColItemInner>
        </GridHourColItem>
      ))}
  </GridHourCol>
);

function getHourString(hour) {
  const date = new Date();
  date.setHours(hour, 0, 0);
  return `${moment(date).format("HH")}:00`;
}

export default React.memo(HourColumn);
